import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

//material ui components
import {
  Alert,
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

//project components
import GeneralInfo from "./general-info";
import SidePanel from "./side-panel";
import Qualification from "./qualification";
import WorkExperience from "./work-experience";
import config from "../../../config";
import AppliedJobs from "./applied-jobs";

//third party
import axios from "axios";
import useAxiosAuth from "../../../hooks/useAxiosAuth";

import Followup from "./candidate-followups";
import CandidateSpecialization from "./candidate-specializations";
import Payment from "./candidate-payments";
import CustomTransliterateTextField from "../../../ui-component/CustomTransliterateTextField";
import { convertDateToLocalReverse } from "../../../utils/date-operations";

const Profile = () => {
  //Constants
  const navigate = useNavigate();
  const theme = useTheme();
  const axiosAuth = useAxiosAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const { userId, profileId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  //States
  const [candidate, setCandidate] = useState();
  const [selectedPage, setSelectedPage] = useState(0);
  const [candidateComments, setCandidateComments] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("Success");
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Error");
  const [commentError, setCommentError] = useState("");
  const [registrationData, setRegistrationData] = useState();
  const [charges, setCharges] = useState(0);
  const [placementCharges, setPlacementCharges] = useState();

  const [fromDate, setFromDate] = useState(
    convertDateToLocalReverse(new Date())
  );
  const [toDate, setToDate] = useState(convertDateToLocalReverse(new Date()));
  //Methods
  const getCandidateDetails = () => {
    let id = 1;
    if (role === 1 || role === 2) {
      id = searchParams.get("ref");
      if (id === null) {
        navigate("/");
        return;
      }
    } else if (role === 4) {
      id = profileId;
    } else {
      navigate("/");
      return;
    }
    axiosAuth
      .get("/api/Candidates/" + id)
      .then((response) => {
        const candidateData = response.data;
        setCandidate(candidateData);
        setCandidateComments(candidateData?.commentBox);
        if (candidateData?.candidateRegistrations?.length > 0) {
          const firstReg = candidateData?.candidateRegistrations[0];
          setFromDate(convertDateToLocalReverse(firstReg?.startDate));
          setToDate(convertDateToLocalReverse(firstReg?.endDate));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSave = () => {
    getCandidateDetails();
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSuccessOpen(false);
  };

  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setErrorOpen(false);
  };
  const handleCommentChange = (val) => {
    setCandidateComments(val);
    if (val?.length <= 255) {
      setCommentError("");
    } else {
      setCommentError("Comments must be 255 characters or less");
    }
  };
  //useEffects
  useEffect(() => {
    getCandidateDetails();
  }, [searchParams.get("ref")]);
  useEffect(() => {
    if (candidate?.candidateRegistrations?.[0]?.charges !== undefined) {
      setCharges(candidate.candidateRegistrations[0].charges);
    }
  }, [candidate]);
  useEffect(() => {
    if (candidate?.placementCharges !== undefined) {
      setPlacementCharges(candidate.placementCharges);
    }
  }, [candidate]);
  console.log("candidate", candidate);
  return (
    <Grid container maxWidth="xl" sx={{ marginX: "auto", paddingY: 3 }}>
      {candidate != undefined ? (
        <Grid container spacing={2} sx={{ padding: 1 }}>
          <Grid item xs={12} md={3}>
            <SidePanel
              candidate={candidate}
              documents={candidate?.candidateDocuments}
              onSave={getCandidateDetails}
              setSelectedPage={setSelectedPage}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            {selectedPage === 0 ? (
              <Stack direction="column" spacing={2}>
                <GeneralInfo candidate={candidate} onSave={handleSave} />
                {/* {role === 1 && candidate.isPlaced === true && (
                  <Card elevation={4} sx={{ padding: 2 }}>
                    <Grid container spacing={2} direction="row">
                      <Grid item xs={12}>
                        <Typography variant="h6">Placement Status</Typography>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Box
                          display="flex"
                          height="100%"
                          alignItems="center"
                          justifyContent="flex-start"
                        >
                          <Chip
                            label={"Placed"}
                            color={
                              candidate.isPlaced === true
                                ? "success"
                                : "warning"
                            }
                            variant="filled"
                            sx={{ fontWeight: "bold", px: 3 }}
                          />
                        </Box>
                      </Grid>
                      {candidate.isPlaced === true && (
                        <>
                          <Grid item xs={12} md={3}>
                            <TextField
                              name="charges"
                              type="number"
                              label="Charges"
                              value={placementCharges}
                              onChange={(e) =>
                                setPlacementCharges(e.target.value)
                              }
                              fullWidth
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <Button
                              variant="outlined"
                              sx={{
                                width: 150,
                                backgroundColor: theme.palette.secondary.light,
                              }}
                              onClick={() => {
                                axiosAuth
                                  .patch(
                                    `/api/Candidates/update-placement-charges?id=${candidate?.id}&placementCharges=${placementCharges}`
                                  )
                                  .then((response) => {
                                    if (response.status === 200) {
                                      getCandidateDetails();
                                      setSuccessMsg(
                                        "Placement charges updated successfully!"
                                      );
                                      setSuccessOpen(true);
                                    } else {
                                      setErrorMsg(
                                        "Error in updating registration."
                                      );
                                      setErrorOpen(true);
                                    }
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    setErrorMsg(
                                      "Error in updating registration."
                                    );
                                    setErrorOpen(true);
                                  });
                              }}
                            >
                              Save
                            </Button>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Card>
                )} */}
                {/* {role === 1 && (
                  <Card elevation={4} sx={{ padding: 2 }}>
                    <Grid container spacing={2} direction="row">
                      <Grid item xs={12}>
                        <Typography variant="h6">
                          Registration Status
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Box
                          display="flex"
                          height="100%"
                          alignItems="center"
                          justifyContent="flex-start"
                        >
                          <Chip
                            label={candidate.registrationStatusDisplay}
                            color={
                              candidate.registrationStatus === 1
                                ? "success"
                                : "warning"
                            }
                            variant="filled"
                            sx={{ fontWeight: "bold", px: 3 }}
                          />
                        </Box>
                      </Grid>
                      {candidate.registrationStatus === 1 && (
                        <>
                          <Grid item xs={12} md={3}>
                            <TextField
                              name="startDate"
                              type="date"
                              label="Start Date"
                              value={fromDate}
                              onChange={(e) => setFromDate(e.target.value)}
                              fullWidth
                              size="small"
                            />
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <TextField
                              name="endDate"
                              type="date"
                              label="End Date"
                              value={toDate}
                              onChange={(e) => setToDate(e.target.value)}
                              fullWidth
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              name="charges"
                              type="number"
                              label="Charges"
                              value={charges}
                              onChange={(e) => setCharges(e.target.value)}
                              fullWidth
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                          <Grid item xs={12}>
                            <Button
                              variant="outlined"
                              sx={{
                                width: 150,
                                backgroundColor: theme.palette.secondary.light,
                              }}
                              onClick={() => {
                                const registration =
                                  candidate?.candidateRegistrations?.[0]; // get first registration safely
                                // if (!registration) {
                                //   setErrorMsg("No registration record found.");
                                //   setErrorOpen(true);
                                //   return;
                                // }

                                axiosAuth
                                  .patch(
                                    `/api/CandidateRegistrations?id=${registration?.id}&startDate=${fromDate}&endDate=${toDate}&charges=${charges}`
                                  )
                                  .then((response) => {
                                    if (response.status === 200) {
                                      getCandidateDetails();
                                      setSuccessMsg(
                                        "Registration updated successfully!"
                                      );
                                      setSuccessOpen(true);
                                    } else {
                                      setErrorMsg(
                                        "Error in updating registration."
                                      );
                                      setErrorOpen(true);
                                    }
                                  })
                                  .catch((error) => {
                                    console.log(error);
                                    setErrorMsg(
                                      "Error in updating registration."
                                    );
                                    setErrorOpen(true);
                                  });
                              }}
                            >
                              Save
                            </Button>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Card>
                )} */}
                {role === 1 && (
                  <Card elevation={4} sx={{ padding: 2 }}>
                    <Stack direction="column" spacing={2}>
                      <Typography variant="h6">Comments</Typography>
                      <CustomTransliterateTextField
                        id="comment"
                        name="comment"
                        value={candidateComments}
                        onChangeText={handleCommentChange}
                        lang="mr"
                        //label="Comments"
                        isError={!!commentError}
                        error={commentError}
                        multiline
                        rows={3}
                      />

                      <Button
                        variant="outlined"
                        sx={{
                          width: 150,
                          backgroundColor: theme.palette.secondary.light,
                        }}
                        onClick={() => {
                          axiosAuth
                            .put(
                              "/api/Candidates/update-comments?id=" +
                                candidate.id +
                                "&comments=" +
                                candidateComments
                            )
                            .then((response) => {
                              if (response.status === 200) {
                                getCandidateDetails();
                                setSuccessMsg("Comments updates successfully!");
                                setSuccessOpen(true);
                              } else {
                                setErrorMsg("Error in updating comments.");
                                setErrorOpen(true);
                              }
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        }}
                      >
                        Save Comments
                      </Button>
                    </Stack>
                  </Card>
                )}
                <Qualification
                  qualifications={candidate.candidateQualifications}
                  candidateId={candidate.id}
                  onSave={handleSave}
                />
                {candidate?.jobExperience != 1 && (
                  <WorkExperience
                    workExperiences={candidate.candidateWorkExpriences}
                    candidateId={candidate.id}
                    onSave={handleSave}
                  />
                )}
                <CandidateSpecialization
                  candidateSpecializations={candidate.candidateSpecializations}
                  candidateId={candidate.id}
                  onSave={handleSave}
                />
                {/* <Payment
                  payments={candidate.candidatePayments}
                  candidateId={candidate.id}
                  onSave={handleSave}
                /> */}
                {role === 1 && (
                  <Followup
                    followups={candidate.candidateFollowUps}
                    candidateId={candidate.id}
                    onSave={handleSave}
                  />
                )}
              </Stack>
            ) : (
              <AppliedJobs candidateId={candidate.id} />
            )}
          </Grid>
        </Grid>
      ) : null}

      <Snackbar
        open={successOpen}
        autoHideDuration={6000}
        onClose={handleSuccessClose}
      >
        <Alert
          onClose={handleSuccessClose}
          severity="success"
          sx={{
            width: "100%",
            backgroundColor: "#009933",
            color: theme.palette.white.main,
          }}
          variant="filled"
        >
          {successMsg}
        </Alert>
      </Snackbar>

      <Snackbar
        open={errorOpen}
        autoHideDuration={6000}
        onClose={handleErrorClose}
      >
        <Alert
          onClose={handleErrorClose}
          severity="error"
          sx={{ width: "100%" }}
          variant="filled"
        >
          {errorMsg}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default Profile;
